import { Metamodel } from 'app/model/base/model';
import { TabularCopySource } from './tabular-type.copysource';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { PostgreSqlDataset } from 'app/model/dataset/postgre-sql.dataset';
import { format, getConnectorLegacyNameByFlag } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: adfModelTypeMap.postgreSql.copySourceType,
    disabled: __IS_FABRIC_DPE__,
    display: [
        format(stringResources.ModelName_CopySourceTemplate, getConnectorLegacyNameByFlag(stringResources.PostgreSql_DisplayText, true)),
        format(stringResources.ModelName_CopySourcesTemplate, getConnectorLegacyNameByFlag(stringResources.PostgreSql_DisplayText, true))
    ],
    tags: {
        datasetModel: [
            Metamodel.modelFor(PostgreSqlDataset)
        ]
    }
})
export class PostgreSqlCopySource extends TabularCopySource {
}
